module.exports = __webpack_public_path__ + "static/media/Banner.0d02b075.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/liveClasses/Banner.png
// module id = 301
// module chunks = 4 6 7